const paymentOtherReducer = (state = '', action) => {
	switch(action.type){
	case 'PAYMENTOTHERUPDATE':	
		return action.payload;
	default:
		return state;
	}
}

export default paymentOtherReducer;